import React from "react";
import styled, {css} from 'styled-components';
import {BrowserRouter as Router,Link, Route} from "react-router-dom";
import titleBack from '../pictures/titleBack.jpg';
import profilepic from '../pictures/profile.png';
import bookpic from '../pictures/book.png';
import pcpic from '../pictures/pc.png';
import mailpic from '../pictures/mail.png';
import twitterpicColor from '../pictures/twitterColor.png';
import puzzlepic from '../pictures/puzzle.jpg';
import flipcardspic from '../pictures/flipcards.jpg';
import todopic from '../pictures/todo.jpg';
import recipepic from '../pictures/recipe.jpg';
import gifpic from '../pictures/gif.jpg';
import portfoliopic from '../pictures/portfolio.jpg';

class Top extends React.Component {
render(){
    const globalStyles = css`
    `
    const LinkStyled = styled(Link)`
    ${globalStyles}
    `
    const LinkStyledButton = styled(LinkStyled)`
        width: 5em;
        height: 3em;
        line-height: 3em;
        margin: 2em;
        padding: 0.5em 1.5em;
        font-size:calc(10px + 0.4vw)
        font-weight: bold;
        color: white;
        border-style: none;
        border-radius: 3px;
        text-decoration: none;
        background-color: #0F4137;
    `
    const TITLE = styled.div`
        height: 12em;
        line-height: 14em;
        background-image: url("${titleBack}");
        background-size: cover;
        font-size: 3.5vw;
        color: white;
        font-weight: bold
        text-align: center;
        `;

    const TITLESHADOW = styled.div`
        background-color: rgba(0,0,0,.6);
        height: 12em;
        `;

    const PROFILE = styled.div`
        height: 25em;
        display: flex;
        justify-content: space-around;
        align-items: center;
        `;

    const PROFILETEXT = styled.div`
        width: 70%;
        font-size: calc(10px + 0.4vw) ;
        padding: 0.5em;
        `;

    const PROFILEIMG = styled.img`
        width: calc(40px + 20vw);
        height: calc(40px + 20vw);
        padding: 0.5em;
        `;

    const SKILLS = styled.div`
        text-align: center;
        font-size:calc(10px + 0.4vw)
        `;

    const CONTENTICON = styled.img `
        width: calc(15px + 5vw);
        height:calc(15px + 5vw);
        margin-top: 1em;
    `;

    const CONTENTSTITLE = styled.h2`
        margin-top: 0;
        color: #0F4137;
        font-size: font-size:calc(15px + 0.4vw);
    `;

    const SKILL = styled.div`
        background-color: #f4f4f4;
        padding: 1em
    `;

    const SKILLTITLE = styled.h3`
        color: black;
    `;

    const SKILLCONTENT = styled.p`
        color: black;
    `;

    const WORKS = styled.div`
        text-align: center;
        font-size:calc(10px + 0.4vw)
        `;

    const WORK = styled.div`
        display: flex;
        justify-content: space-around;
        background-color: #f4f4f4;
        padding: 2em;
    `;

    const WORKTITLE = styled.h4`
        color: black;
    `;

    const WORKIMG = styled.img`
        width: calc(40px + 20vw);
        height: calc(70px + 30vw);
        padding: 0.5em;
        `;

    const WORKBOX = styled.div`
        width: 15em;
        height: 23em;
    `;

    const WORKCONTENT = styled.p`
        color: black;
    `;
    
    const CONTACTS = styled.div`
        text-align: center;
        font-size:calc(10px + 0.4vw)
        `;

    const CONTACT = styled.div`
        display: flex;
        justify-content: space-around;
        background-color: #f4f4f4;
        font-size:calc(10px + 0.4vw)
        `;

    const CONTACTBOX = styled.div`
        width: 50%;
        padding: 1.5em; 
    `;

    const CONTACTTITLE = styled.a`
        color: black;
    `;

    const CONTACTICON = styled.img`
        width: calc(15px + 5vw);
        height:calc(15px + 5vw);
        padding: 0.5em;
        `;

    const MESSAGE = styled.p`
        padding: 1em;  
    `
return(
<div>
    <TITLE>
    <TITLESHADOW>
        WELCOME TO MY PORTFOLIO!
    </TITLESHADOW>
    </TITLE>
    <PROFILE>
        <PROFILEIMG src= {profilepic} />
        <PROFILETEXT>
            Yuki AMAKAWA<br/><br/>
            法学部卒業後、特許事務所で2年間事務・翻訳を担当。<br/>
            2017年10月からHTML、CSS、JavaScriptを勉強しはじめ、もっとJSで色々なものを作りたいと思いReact.jsを始めました。<br/>
            転職を決めたきっかけは趣味のトルコ語×プログラミングで作った「時刻をトルコ語で表示する時計」。<br/>外国語学習アプリにトルコ語で掲載したところ
            多くの反応をもらい、エンジニアになって自分が作った物を多くの人に使ってもらいたいと感じました。<br/>
            その後は本やUdemyで独学を続け、2018年3月からは名古屋市内の勉強会にも参加しています。<br/>
            
        </PROFILETEXT>
    </PROFILE>

    <SKILLS>
        <CONTENTICON src= {bookpic} alt=""/>
        <CONTENTSTITLE>skills</CONTENTSTITLE>
        <SKILL>
            <SKILLTITLE>
                英語
            </SKILLTITLE>
            <SKILLCONTENT>
                英文メール(2年半)<br/>
                現職では国内企業と海外特許事務所の仲介を行うため<br/>日常的に英文メールでのやりとりをしています。<br/><br/>
                翻訳業務(2年)<br/>
                特許出願の中間手続において、補正書・意見書の英訳を担当。<br/>2年半で分野は主に自動車関連。<br/><br/>

                
                資格<br/>
                TOEIC　845点<br/>
                工業英検2級<br/><br/>

            </SKILLCONTENT>

            <SKILLTITLE>
                知的財産法<br/>
            </SKILLTITLE>
            <SKILLCONTENT>
            大学で知的財産法(特許法、著作権法など)を主に学びました。<br/>
            現在は特許事務所に勤務し、国内外の特許出願手続・管理を担当しています。<br/>
            インターフェースの著作権、プログラミングの特許など<br/>
            最近はWebアプリケーションの設計やデザインに関連のある法律や判例も勉強しています。<br/><br/>

            </SKILLCONTENT>
        </SKILL>
    </SKILLS>

    <WORKS>
        <CONTENTICON src= {pcpic} alt=""/>
        <CONTENTSTITLE>WORKS</CONTENTSTITLE>
        <WORK>
            <WORKIMG src= {puzzlepic} alt=""/>
            <WORKBOX>
                <WORKTITLE>
                    数字パズル
                </WORKTITLE>
                <WORKCONTENT>
                    隣どうしのマスを入れ替えて数字を順番に並べてください。<br/>クリアするとレベル2の曜日パズルに進めます。
                </WORKCONTENT>
                <LinkStyledButton to='/puzzle'>
                詳細
                </LinkStyledButton>
            </WORKBOX>
        </WORK> 

        <WORK>
            <WORKIMG src= {flipcardspic} alt=""/>
            <WORKBOX>
                <WORKTITLE>
                    トルコ語神経衰弱
                </WORKTITLE>
                <WORKCONTENT>
                    カードのイラストと対応する単語をそろえる神経衰弱です。<br/>カードがそろうと猫ちゃんが喜びます。
                    トルコ語ですが詳細ページに答えがあるので参照してください。
                </WORKCONTENT>
                <LinkStyledButton to='/flipcards'>
                詳細
                </LinkStyledButton>
            </WORKBOX>
        </WORK>

        <WORK>
            <WORKIMG src= {todopic} alt=""/>
            <WORKBOX>
                <WORKTITLE>
                    Todoリスト
                </WORKTITLE>
                <WORKCONTENT>
                    TODOと期限日を設定できるリストです。<br/>
                    期限日までの残り日数が表示され、残り日数が短い順にTODOが並びます。
                </WORKCONTENT>
                <LinkStyledButton to='/todo'>
                詳細
                </LinkStyledButton>
            </WORKBOX>
        </WORK>

        <WORK>
            <WORKIMG src= {recipepic} alt=""/>
            <WORKBOX>
                <WORKTITLE>
                    レシピアプリ
                </WORKTITLE>
                <WORKCONTENT>
                    自分のレシピを投稿できます。<br/>
                    投稿されたレシピは画面下部のリストに追加され、クリックすることでレシピ詳細を確認できます。
                </WORKCONTENT>
                <LinkStyledButton to='/recipe'>
                詳細
                </LinkStyledButton>
            </WORKBOX>
        </WORK>

        <WORK>
            <WORKIMG src= {gifpic} alt=""/>
            <WORKBOX>
                <WORKTITLE>
                    GIF検索
                </WORKTITLE>
                <WORKCONTENT>
                    検索フォームに好きな単語を入れるとGIFを検索することができます。
                </WORKCONTENT>
                <LinkStyledButton to='/gif'>
                詳細
                </LinkStyledButton>
            </WORKBOX>
        </WORK>

        <WORK>
            <WORKIMG src= {portfoliopic} alt=""/>
            <WORKBOX>
                <WORKTITLE>
                    YUKI'S PORTFOLIO
                </WORKTITLE>
                <WORKCONTENT>
                    現在ご覧になっているサイトです。
                </WORKCONTENT>
                <LinkStyledButton to='/portfolio'>
                詳細
                </LinkStyledButton>
            </WORKBOX>
        </WORK>
    </WORKS>

    <CONTACTS>
        <CONTENTICON src= {mailpic} alt=""/>
        <CONTENTSTITLE>Contacts</CONTENTSTITLE>
        <CONTACT>
            <CONTACTBOX>
                <CONTACTICON src= {twitterpicColor} /><br/>
                <CONTACTTITLE href="https://twitter.com/YuKi313230323?lang=ja&lang=ja" target="_blank">
                    Twitter:<br/>@YuKi313230323
                </CONTACTTITLE> 
            </CONTACTBOX>
            <CONTACTBOX>
                <CONTACTICON src= {mailpic} /><br/>
                <CONTACTTITLE href="mailto:clalto31202@gmail.com" target="_blank">
                    Email:<br/>clalto31202@gmail.com
                </CONTACTTITLE>
            </CONTACTBOX>
        </CONTACT>
        <MESSAGE>平日のメール返信は20時以降となります。ご了承ください。</MESSAGE>
        <MESSAGE>©Yuki Amakawa</MESSAGE>
    </CONTACTS>
</div>
)}}

export default Top




// WEBPACK FOOTER //
// ./src/components/Top.js